<section id="bottom-footer" class="intro2">
  <div class="container">
    <!-- footer section -->
    <div class="footer-section">
      <!-- <div class="unifiedNo text-center text-white mb-4">
        <h5 class="mb-3">الرقم الموحد</h5>
        <h2 class="font-size-40">932056896</h2>
      </div> -->

      <div class="row space-between">
        <div class="col-lg-6 col-sm-12">
          <h3>دليل مركز سلاسة</h3>
          <div class="footer-links row">
            <div class="col-lg-4">
              <ul class="sm-links">
                <li>
                  <!-- <i class="fas fa-caret-left"></i> -->
                  <a href="/"> الرئيسية</a>
                </li>
                <li>
                  <!-- <i class="fas fa-caret-left"></i> -->
                  <a href="/MedicalPlatform">المنصة العلاجية </a>
                  <div class="sub-links">
                    <li><a href="/MedicalPlatform">التعريف بالمنصة</a></li>
                    <li><a href="/auth/basic-data/Platform">التشخيص</a></li>
                    <li><a href="/Sas/TreatmentPlatform">العلاج</a></li>
                  </div>
                </li>
              </ul>
            </div>

            <div class="col-lg-4">
              <ul class="sm-links">
                <li>
                  <!-- <i class="fas fa-caret-left"></i> -->
                  <a href="/Consultant">خدمة مستشارك في التخاطب</a>
                </li>

                <li>
                  <!-- <i class="fas fa-caret-left"></i> -->
                  <a href="">خدماتنا </a>
                  <div class="sub-links">
                    <li><a href="">للمرضى</a></li>
                    <li><a href="">للمختصين</a></li>
                  </div>
                </li>
              </ul>
            </div>

            <div class="col-lg-4">
              <ul class="sm-links">
                <li>
                  <!-- <i class="fas fa-caret-left"></i> -->
                  <a href="/AboutUs">من نحن</a>
                </li>
                <li>
                  <!-- <i class="fas fa-caret-left"></i> -->
                  <a href="/MedicalCenter">المركز العلاجى</a>
                  <div class="sub-links">
                    <li><a href="/MedicalCenter">عن المركز العلاجى</a></li>
                    <li><a href="/Default#Specialties">التخصصات</a></li>
                    <li><a href="#">حجز موعد</a></li>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-sm-12">
          <h3>ابقى علي تواصل</h3>
          <p>ابقى علي تواصل معنا عن طريق</p>
          <div class="footer-links">
            <ul class="sm-links mb-1">
              <li>
                <!-- <i class="fas fa-map-marker-alt"></i> -->
                <img
                  src="assets/images/icons/location-icon-white.svg"
                  alt="location icon"
                />
                <a href="/ContactUs">
                  الطريق الدائري الشمالي، الرياض SA، الرياض 13313</a
                >
              </li>
            </ul>
            <div class="row">
              <ul class="sm-links col-sm-8">
                <li>
                  <!-- <i class="fas fa-phone"></i> -->
                  <img
                    src="assets/images/icons/phone-call-white.svg"
                    alt="phone icon"
                  />

                  <a
                    href="tel:966112455503"
                    target="_blank"
                    dir="ltr"
                    lang="en"
                  >
                    +966112455503
                  </a>
                </li>
                <li>
                  <!-- <i class="fab fa-whatsapp"></i> -->
                  <img
                    src="assets/images/icons/whatsapp-icon-white.svg"
                    alt="whatsapp icon"
                  />

                  <a
                    href="https://wa.me/966112455503"
                    target="_blank"
                    dir="ltr"
                    lang="en"
                  >
                    966112455503
                  </a>
                </li>
                <li>
                  <!-- <i class="far fa-envelope"></i> -->
                  <img
                    src="assets/images/icons/mail-icon-white.svg"
                    alt="mail icon"
                  />

                  <a href="mailto:info@cpt-it.com" target="_blank">
                    info@cpt-it.com
                  </a>
                </li>
              </ul>

              <!-- maroof logo -->
              <div class="col-sm-4 pb-4 text-center">
                <a href="#" target="_blank">
                  <p class="mb-0">تحميل تطبيق الجوال</p>
                  <img
                    src="../../../assets/images/google-play.svg"
                    width="116px"
                    class="pt-2"
                  />
                </a>
                <a href="#" target="_blank">
                  <img
                    src="../../../assets/images/apple-app-store-logo-dark.png"
                    width="116px"
                    class="pt-2"
                    style="border-radius: 11px 11px 6px 7px"
                  />
                  <!-- <img src="../../../assets/images/gold-logo-maroof.png" width="116px" class="pt-2"> -->
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="sm-footer">
    <div class="container">
      <p>جميع الحقوق محفوظة © ل CPTIT</p>
    </div>
  </div>
</section>
